import React, {  Component } from 'react';
import { connect } from 'react-redux';

/*Actions*/
import {
    getDocuments
} from '../../../../redux/actions';

class AdvertisingPortal extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        const typeOfAccount = this.props.getSelectedAccountType();
        return (
           (typeOfAccount === 'RETAIL')? <div>
                <img src={"/images/Portal Home Page Banner.png"} width={1040} height={250} alt="Advertising portal home" title="Advertising portal home" /> 
                <div style={{display:"flex"}}>
                <div style={{width:"65%",  padding: "0px 60px 10px 60px", textAlign: 'center'}}>
                        <h4>{`FIRST TIME USERS`}</h4>
                        <blockquote style={{textAlign:"left"}}>
                            {`To gain access to the portal, click the link below and select “sign up for a Brandfolder account”. After creating your account and identifying a password, you will have access to AdBuilder. `}
                        </blockquote>
                        <a href="https://forms.office.com/r/RP0gzjyceP" target='_blank'>{`AdBuilder Invitation`}</a>
                    </div>
                    <div  style={{width:"65%",  padding: "0px 60px 10px 60px", textAlign: 'center'}}>
                        <h4 style={{textAlign: 'center' }} >{`RETURNING USERS`}</h4>
                        <blockquote style={{textAlign:"left"}}>
                            {`We recommend bookmarking the link below to access the AdBuilder platform on your internet browser.`}
                        </blockquote>
                            <a href="https://brandfolder.com/portals/geappliances_adbuilder" target='_blank'>{`https://brandfolder.com/portals/geappliances_adbuilder` }</a>
                    </div>
                </div>  
                <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{width: "50%", padding: "0px 50px ", boxSizing: "border-box", display: "flex", justifyContent: "center"}}>
                <img src={"/images/AdBuilder_Sign_in_Screenshot.png"} width={350} height={250} alt="AdBuilder Sign In" title="AdBuilder Sign In" style={{ border: "2px solid rgb(136, 127, 127)" }} />
                    </div>
                    <div style={{width: "50%",padding: "0px 50px", boxSizing: "border-box", display: "flex", justifyContent: "center"}}>
                    <img src={"/images/AdBuilder_Screenshot.jpg"} width={350} height={250} alt="AdBuilder Screenshot" title="AdBuilder Screenshot" style={{ border: "2px solid rgb(136, 127, 127)" }}  />
                    </div>
                </div>      
            </div>: <div>
             <img src={"/images/Welcome to THE HUB.png"} width={1040} height={250} alt="Welcome to hub" title="Welcome to hub" /> 
             <div style={{display:"flex"}}>
             <div style={{width:"65%",  padding: "0px 60px 10px 60px", textAlign: 'center'}}>
                     <h4>{`FIRST TIME USERS`}</h4>
                     <blockquote style={{textAlign:"left"}}>
                         {`To gain access to the portal, click the link below and select “sign up for a Brandfolder account”. After creating your account and identifying a password, you will have access to AdBuilder. `}
                     </blockquote>
                     <a href="https://forms.office.com/r/RP0gzjyceP" target='_blank'>{`The Hub Invitation` }</a>
                 </div>
                 <div  style={{width:"65%",  padding: "0px 60px 10px 60px", textAlign: 'center'}}>
                     <h4 style={{ textAlign: 'center'}} >{`RETURNING USERS`}</h4>
                     <blockquote style={{textAlign:"left"}}>
                         {`We recommend bookmarking the link below to access the AdBuilder platform on your internet browser.`}
                     </blockquote>
                         <a href="https://brandfolder.com/portals/geappliances_thehub" target='_blank'>{`https://brandfolder.com/portals/geappliances_thehub` }</a>
                 </div>
             </div>  
             <div style={{ display: "flex", alignItems: "center" }}>
                 <div style={{width: "50%", padding: "0px 50px ", boxSizing: "border-box", display: "flex", justifyContent: "center"}}>
                 <img src={"/images/The_Hub_Sign_in_Screenshot.png"} width={350} height={250} alt="Hub Sign In" title="Hub Sign In" style={{ border: "2px solid rgb(136, 127, 127)" }} />
                 </div>
                 <div style={{width: "50%",padding: "0px 50px", boxSizing: "border-box", display: "flex", justifyContent: "center"}}>
                 <img src={"/images/brandfolder.com_portals_geappliances_thehub.png"} width={350} height={250} alt="Hub Screenshot" title="Hib Screenshot" style={{ border: "2px solid rgb(136, 127, 127)" }}  />
                 </div>
             </div>      
         </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {state};
};

const mapDispatchToProps = (dispatch) => ({
    getDocuments: (queryStringParams, willSaveToStore, callback) => dispatch(getDocuments(queryStringParams, willSaveToStore, callback)),
});

AdvertisingPortal = connect(mapStateToProps, mapDispatchToProps)(AdvertisingPortal);
export default AdvertisingPortal;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Resources/AdvertisingPortal/index.js